export default __webpack_public_path__ + "static/OpenSans-Bold-c790f99966352c531503674ee0f6be9c.ttf";